


























import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import WorkflowDynamicForm from '@/components/workflow/WorkflowDynamicForm.vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import { ScriveWorkflowJob, ObjectHelper, TabsHelper } from '@/mixins';

export default Vue.extend({
  name: 'ScriveSignersTab',
  mixins: [ScriveWorkflowJob, ObjectHelper, TabsHelper],
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    isWorkflowJobLocked: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    ...mapActions('scriveWorkflowJobStore', ['getSignersTab']),
    getScriveSignersTabData(this: any) {
      this.getSignersTab(this.workflowJob.jobId);
    }
  },
  computed: {
    ...mapGetters('workflowJobStore', ['workflowDataSourceField', 'workflowJob']),
    ...mapGetters('scriveWorkflowJobStore', ['signersTab', 'isSignersTabLoading'])
  },
  watch: {
    isSignersTabLoading(this: any, value: boolean) {
      if (!value) {
        this.handleTabsLoaded();
      }
    }
  },
  mounted() {
    this.getScriveSignersTabData();
  },
  components: {
    WorkflowDynamicForm,
    LoadingSpinner
  }
});
